import { connect } from "react-redux";

import Layout from "./layout";
import { AppState } from '../../core/reducers/rootReducer';
import { getTransactionIdFromURL, isUserLoggedIn } from '../../constants/utils';


const mapStateToProps = (state: AppState) => {
  let txnId = getTransactionIdFromURL();
  return {
    isAuthenticated: isUserLoggedIn(txnId),
    isLoading: state.isLoading,
    partnerName: state.auth.partnerName
  };
};

export default connect(
  mapStateToProps,
  null
)(Layout);
